import { render, staticRenderFns } from "./CheckoutPaymentMethods.vue?vue&type=template&id=4f8a8f8a&scoped=true&"
import script from "./CheckoutPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPaymentMethods.vue?vue&type=style&index=0&id=4f8a8f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a8f8a",
  null
  
)

export default component.exports